import store from "@/store/index.js";
import translations from "@/shared/services/i18n/Translations.js";
import numberFormats from "@/shared/services/i18n/NumberFormats.js";
import LazLocalStorage from "@/shared/utils/LazLocalStorage.js";

/* Set application language from localStorage  */
const langCode = LazLocalStorage.getWithExpiry("LazLangCode");
if (langCode != null) {
  store.dispatch("SetLangCode", langCode);
  console.info("LangCode Restored - " + langCode);
} else {
  store.dispatch("SetLangCode", "en");
  console.info("LangCode Initialized - en");
}

// Create VueI18n instance options
const i18nOptions = {
  locale: store.getters.langCode, // set locale
  fallbackLocale: "en", // fallback in case not found.
  messages: translations, // set locale messages
  numberFormats, // set locale number formattings
};

export default i18nOptions;
